var Authorization = 'Bearer vbsAM5rergtVaQdPManixQMDyrwoYKoBI13ZGHAu';

var url = window.location.href,
    parts = url.split("/"),
    last_part = parts[parts.length-1];

var totalPage = '16';

if(last_part == ''){
    last_part = parts[parts.length-2];
}
var flag=0;

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function formatDateString (date,format='regular',time='') {
  var days = ["SO", "MO", "DI", "MI", "DO", "FR", "SA"];

  var newDate = date.split(' ');
  var newTime = newDate[1].split(':');
  
  date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);
  
  
  var month = d.getUTCMonth()+1;
  var day = d.getUTCDate();
  var dayname = days[d.getUTCDay()];
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();

  if (month.length < 2) {
    month = '0' + month;
  }
  
  var min = '',
      h = '',
      dt = '',
      mt = '',
      tm = '';

  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(day < 10){
  	dt = 0;
  }
  if(month < 10){
  	mt = 0;
  }
  if(time=='false'){
    tm = '';
  }else{
    // tm = ', '+h+hour+':'+min+minute;
    tm = ', '+newTime[0]+':'+newTime[1];
  }

  
  
  return (dayname+', '+dt+day+'.'+ mt+month+'.'+ year+tm);
}

const formatDate = (date,syear='true') => {
  const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni","Juli", "August", "September", "Oktober", "November", "Dezember"];
  var newDate = date.split(' ');
  var newTime = newDate[1].split(':');
  
  date = newDate[0]+'T'+newDate[1]+'Z';
  var d = new Date(date);
  
  var month = (monthNames[d.getUTCMonth()]).toString();
  var day = d.getUTCDate().toString();
  var year = d.getUTCFullYear();
  var hour = d.getUTCHours();
  var minute = d.getUTCMinutes();
  if (month.length < 2) {
    month = '0' + month;
  }

  var min = '',
    h = '';
  if (day.length < 2) {
    day = '0' + day;
  }
  if(minute < 10){
  	min = 0;
  }
  if(hour < 10){
  	h = 0;
  }
  if(syear == 'false'){
    year = newTime[0]+':'+newTime[1];
  }
  
  return (day+'. '+month+' '+ year);
}

function youtube_parser(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
}

var currentLang = 'de_CH';
$(document).ready(function(){
  var slidetoshow=7;

  if(getParameterByName('page') == null){
    var pageno = 1;
  }else{
    var pageno = getParameterByName('page')
  }
  if(getParameterByName('category') == null){
    var cat = '';
  }else{
    var cat = getParameterByName('category');
  }
  if(getParameterByName('player') == null){
    var plyr = '';
  }else{
    var plyr = getParameterByName('player');
  }
  
  if(last_part.indexOf('news?page') != -1){
    var q = "?page[number]="+pageno+"&page[size]="+totalPage+"&sort=-publishDate&filter[isActive]=1";
  }
  else{
    if(last_part == 'news'){
      var q = "?page[number]="+pageno+"&page[size]="+totalPage+"&sort=-publishDate&filter[isActive]=1";
    }else{
      if(getParameterByName('category') == null){
        if(plyr != ''){
          var q = "?page[number]="+pageno+"&page[size]="+totalPage+"&sort=-publishDate&filter[isActive]=1&filter[b2cId]="+plyr;
        }else{
          if(last_part.indexOf('?') != -1){
            last_part = last_part.split('?')[0];
          }
          var q = '/'+last_part;
          if(!$.isNumeric(last_part)){
            var q = '?filter[urlHandle]='+last_part;
          }
          //       var q = '/3';
          flag++;
          $('.news-list-wrapper').addClass('hidden');
        }
      }
      else{
        var q = "?page[number]="+pageno+"&page[size]="+totalPage+"&sort=-publishDate&filter[isActive]=1&filter[newsCategoryId]="+getParameterByName('category');
      }
    }
  }

  // console.log(q);
  
  var settings = {
    "url": "https://app.aico.swiss/19853/api/v1/news"+q,
    "method": "GET",
    "timeout": 0,
    "headers": {
      "Authorization": Authorization,
      "Accept": "application/vnd.api+json",
    }
  };
  $.ajax(settings).done(function (response) {
    //console.log(response);    
    var totalData = response.data.length;
    var html = '';
        
    if(typeof totalData == 'undefined' || flag > 0)
    {

    if(response.data.length == 0){
      $('#status').fadeOut();
      $('#preloader').fadeOut('slow');
      $('.page-wrapper').remove();
      $('#news-container').addClass('news-details-wrapper');
      $('body').addClass('news-details');
      $('#news-details-container').removeClass('hidden');
      html += '<h3>News not available</h3>';
      
    }
      if(typeof totalData == 'undefined'){
        var newsCat = response.data.attributes.newsCategory;
      }else{
        var newsCat = response.data[0].attributes.newsCategory;
      }
      
      var nq = '';
      if(newsCat != null){
        nq = '&filter[newsCategoryId]='+newsCat.translations[0].id;
      }
      
      
      var settings = {
        "url": "https://app.aico.swiss/19853/api/v1/news?page[number]=1&page[size]=4&filter[isActive]=1&sort=-publishDate"+nq,
        "method": "GET",
        "timeout": 0,
        "headers": {
          "Authorization": Authorization,
          "Accept": "application/vnd.api+json"
        },
      };

      $.ajax(settings).done(function (responsen) {
      var totalNewsData = responsen.data.length;        

      $('#status').fadeOut();
      $('#preloader').fadeOut('slow');
          
      $('.page-wrapper').remove();
      $('#news-container').addClass('news-details-wrapper');
      $('body').addClass('news-details');
      $('#news-details-container').removeClass('hidden');
      $("#shopify-section-banner-inner").remove();
        
      if(typeof totalData == 'undefined'){
        var data = response.data.attributes;
      }else{
        var data = response.data[0].attributes;
      }
      

      var newsTitle = data.name
      $('title').text(newsTitle);

      var img = data.optimizedImage;
      if(data.optimizedImage == null){
        img = data.image;
      }else if(data.image == null){
        img = '';
      }

      var headlineImage = data.headlineImage;
      var isHeadFullWidth = data.isFullWidth;
      var isHeadFullWidthClass = '';
      var newsTagsHTML = '';
      var hasImageClss = '';
      var bgImage = '';
      var newsTags = data.newsTags;
      var newsCategory = data.newsCategory;
      var newsCat = '';

      if(newsCategory != null){
        let translations = newsCategory.translations;
        if(translations.length > 0){
          for(let t=0; t<translations.length; t++){
            let translation = translations[t];
            console.log(translation)
            if(translation.locale == currentLang){
              newsCat = translation.name;
            }
          }
        }        
      }

      if(newsTags.length > 0){
        newsTagsHTML += '<div class="sub-title">';
        for(var nt = 0; nt<newsTags.length; nt++){
          var newsTag = newsTags[nt];
          var translations = newsTag.translations;
          if(translations.length > 0){
            for(var t=0; t<translations.length; t++){
              var translation = translations[t];
              if(translation.locale == currentLang){
               
                if(translation.webName != null){
                   var tagName = translation.webName;
                }
                else {
                   var tagName = translation.name;
                }
                if(tagName){
                   newsTagsHTML += '<h4> '+tagName+' </h4>';
                }                
              }
            }
          }
        }
        newsTagsHTML += '</div>';
      }

      html += '<div class="news-content-wrapper">';

      var headlineImageFocusXPercentage = "";
      if(data.headlineImageFocusXPercentage != null){
        headlineImageFocusXPercentage = data.headlineImageFocusXPercentage+'%';
      }else {
        headlineImageFocusXPercentage = 'top';
      }

      var headlineImageFocusYPercentage = "";
      if(data.headlineImageFocusYPercentage != null){
        headlineImageFocusYPercentage = data.headlineImageFocusYPercentage+'%';
      }else {
        headlineImageFocusYPercentage = 'center';
      }
      
      if(isHeadFullWidth == 1){
        isHeadFullWidthClass = 'isFullWidth';
      }
      if(headlineImage == null || headlineImage == ''){
        hasImageClss="no-bg-image"
      }
      if(headlineImage != null && headlineImage != ''){
        bgImage = "background-image:url('"+headlineImage+"');background-position: "+headlineImageFocusXPercentage+" "+headlineImageFocusYPercentage+";";
        bgImage2 = "url('"+headlineImage+"')";
      }

      html += `
        <div class="head-banner-wrapper ${isHeadFullWidthClass} ${hasImageClss}">
          <div class="head-banner-inner">
            <div class="head-banner lazyload" style="${bgImage}; --divBg:${bgImage2}" id="header-banner">
              <div class="title-wrapper page-width">
                <h1 class="page-title">${newsTitle}</h1>
                ${newsTagsHTML}
              </div>
            </div>
          </div>
        </div>
        `;
        
        html += '<div class="page-width-wrapper page-width">';
          
        if(headlineImage == null && headlineImage == ''){
          html += '<div class="title-block-wrapper">';
            html += newsTagsHTML;
            html += '<div class="title-wrapper">';
              html += '<h2>'+newsTitle+'</h2>';
            html += '</div>';
          html += '</div>';
        }
      
        html += '<div class="blog-artical-wrapper">';
          html += '<div class="blog-artical-inner">';

            var yt,insta;
            if(newsCat == 'St. Gallen'){
              yt = 'https://www.youtube.com/@projektwochest.gallen2633';
              insta = 'https://www.instagram.com/projektwochesg/';
            }else if(newsCat == 'Züri Oberland'){
              yt = '';
              insta = 'https://www.instagram.com/projektwochezh/';
            }else{
              yt = 'https://www.youtube.com/@aiaschweiz';
              insta = 'https://www.instagram.com/athletes.in.action/';
            }

            html += `<div class="share-atrical-wrapper">
                <div class="share-artical-inner">
                  <div class="social-media-heading">IN SOZIALEN MEDIEN TEILEN</div>
                  <ul class="list-social list-unstyled m-0">
                  ${yt != ''?`
                    <li class="list-social__item ms-3">
                      <a class="list-social__link link link--text" href="${yt}" target="_blank" rel="noreferrer">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#ffffff" d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg>                
                      </a>
                    </li>
                    `:''}
                    ${insta != ''?`
                    <li class="list-social__item ms-3">
                      <a class="list-social__link link link--text" href="${insta}" target="_blank" rel="noreferrer">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#ffffff" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"/></svg>
                      </a>
                    </li>
                    `:''}
                  </ul>
                </div>
            </div>`;
            html += '<div class="description-wrapper">';
            var showcontentBuilder = 'false';
            if(data.contentBuilder != null){
              var rows = data.contentBuilder.rows;
              if(rows.length > 0){
                showcontentBuilder = 'true';
                for(var row = 0; row<rows.length; row++ ){
                  var columns = rows[row].columns;
                  var isFullWidth = '';
                  if(rows[row].order != null){
                    var rowOrder = rows[row].order;
                  }else{
                    var rowOrder = '0';
                  }
                  if(rows[row].isFullWidth == 1){
                    isFullWidth = 'fullwidth';
                  }
                  if(columns.length > 0){
                    var totalColumns = columns.length;
                  }else{
                    var totalColumns = 0;
                  }
                  html += '<div class="content-row row__'+(row+1)+' '+isFullWidth+' total-columns-'+totalColumns+'" style="order:'+rowOrder+'">';
                    if(columns.length > 0){
                      for(var column = 0; column < columns.length; column++){
                        var contentContainer  = columns[column].contentContainer;
                        html += '<div class="content-column column__'+(column+1)+'">';
                          if(contentContainer != null){
                            var contents = contentContainer.contents;
                            if(contents.length > 0){
                              for(var content = 0; content < contents.length; content++ ){
                                var isSplit = contents[content].isSplit;;
                                var contentData = contents[content].contentData;
                                var contentType = contents[content].type;
                                if(contents[content].containerOrder != null){
                                  var containerOrder = contents[content].containerOrder;
                                }else{
                                  var containerOrder = '0';
                                }
                                if(contentData != null){
                                  html += '<div class="content content__'+(content+1)+'" style="order:'+containerOrder+'">';
    
                                  var translations = contentData.translations;
                                  if(typeof contentData.translations !== 'undefined'){
                                  // Language translation forloop
                                  for(var t=0; t<translations.length; t++){
                                    var translation = translations[t];
                                    if(translation.locale == currentLang){
    
                                     // console.log(translation.locale,'--',currentLang);
                                      if(contentType == 'HEADING'){
                                        if(contentData.textColor != ''){
                                          var textColor = 'color:'+contentData.textColor;
                                        }else{ var textColor = '';}
                                        html += '<div class="content-type-title">';
                                          html += '<'+contentData.titleSize+' style="'+textColor+'">';
                                            html += translation.title;
                                          html += '</'+contentData.titleSize+'>';
                                          if(translation.description != ''){
                                            html += '<p>'+translation.description+'</p>';
                                          }
                                        html += '</div>';
                                      } // end if contentType HEADING
    
    
                                       if(contentType == 'TITLE'){
                                        if(contentData.textColor != ''){
                                          var textColor = 'color:'+contentData.titleColor;
                                        }else{ var textColor = '';}
                                        html += '<div class="content-type-title">';
                                          html += '<'+contentData.size+' style="'+textColor+'">';
                                            html += translation.title;
                                          html += '</'+contentData.size+'>';
                                          
                                        html += '</div>';
                                      } // end if contentType title
    
    
                                      if(contentType == 'TEXT'){
                                        var description =translation.text;
                                        if(translation.optimizedPicture != null){
                                          var picture = translation.optimizedPicture;
                                        } else if(translation.picture != null){
                                          var picture = translation.picture;
                                        } else {
                                          var picture = '';
                                        }
                                        
                                        html += '<div class="content-type-text">';
                                        
                                        if(picture == ''){
                                          if(translation.title != null){
                                            if(contentData.textColor != '' && contentData.textColor != null){
                                              var textColor = 'color:'+contentData.textColor;
                                            }else{ var textColor = '';}
                                            if(contentData.fontSize != '' && contentData.fontSize != null ){
                                              var textSize = 'font-size:'+contentData.fontSize+'px;';
                                            }else{ var textSize = '' }
                                            
                                            html += '<'+contentData.titleSize+' style="'+textSize+textColor+'">'+translation.title+'</'+contentData.titleSize+'>';
                                          }
                                        }
                                          if(description != null ){
                                             if(contentData.fontSize != '' && contentData.fontSize != null ){
                                              var textSize = 'font-size:'+contentData.fontSize+'px;';
                                            }else{ var textSize = '' }
                                            if(contentData.fontFamily != '' && contentData.fontFamily != null ){
                                              var textFontFamily = 'font-family:'+contentData.fontFamily+'px;';
                                            }else{ var textFontFamily = '' }
                                            html += '<div style="'+textSize+textFontFamily+'"><p>'+description+'</p></div>';
                                          }
                                         
                                          if(picture != ''){
                                            html += '<div class="image-container image-width--'+contentData.pictureSize+' image-text--'+contentData.picturePosition+'" style="text-align:'+contentData.picturePosition+'">';
                                              html += '<div class="image-container-inner">';
                                              html += '<img src="'+picture+'" alt="" class="lazyload" loading="lazy">';
                                              if(translation.pictureLabel != null){
                                                html += '<span class="caption">'+translation.pictureLabel+'</span>';
                                              }
                                              html += '</div>';
                                            html += '</div>';
                                          }
                                        html += '</div>';
                                      } // end if contentType text
    
                                      if(contentType == 'BULLET'){
                                        html += '<div class="content-type-bullet">';
                                          html += '<'+contentData.titleSize+'>'+translation.title+'</'+contentData.titleSize+'>';
                                          if(translation.text != null){
                                            html += '<p>'+translation.text+'</p>';
                                          }
                                          if(contentData.bulletBullets.length > 0){
                                            html += '<ul>';
                                            for(var b = 0; b<contentData.bulletBullets.length; b++){
                                              var translations = contentData.bulletBullets[b].translations;
                                              if(translations.length > 0){
                                                for(var t=0; t<translations.length;t++){
                                                  var translation = contentData.bulletBullets[b].translations[t];
                                                  if(translation.locale == currentLang){
                                                    html +='<li>'+translation.text+'</li>';
                                                  }
                                                }
                                              }
                                            }
                                            html += '</ul>';
                                          }
                                        html += '</div>';
                                      } // end if contentType Bullet
    
                                      if(contentType == 'TABLE'){
                                        
                                        html += '<div class="content-type-table">';
                                          html += '<'+contentData.titleSize+'>'+translation.title+'</'+contentData.titleSize+'>';
                                          html += '<p>'+translation.additionalText+'</p>';
          
                                          if(contentData.tableRows != '' && contentData.tableRows != null ){
                                              html += '<table class="table table-styled">';
                                              for(var b = 0; b<contentData.tableRows.length; b++){
                                                var rowColumns = contentData.tableRows[b].rowColumns;
                                                if(rowColumns.length > 0){
                                                  html += '<tr>';
                                                  for(var rc=0; rc<rowColumns.length; rc++){
                                                    var translations = rowColumns[rc].translations;
                                                    for(var t=0;t<translations.length;t++){
                                                      var translation = translations[t];
                                                      
                                                      if(translation.locale == currentLang){
                                                        html +='<td>'+translation.columnData+'</td>';
                                                      }
                                                    }
                                                  }
                                                  html += '</tr>';
                                                }
                                              }
                                              html += '</table>';
                                            
                                          }
                                          
                                        html += '</div>';
                                      } // end if contentType TABLE
    
                                      if(contentType == 'HTML'){
                                       
                                        html += '<div class="content-type-html">';
                                          html += '<p>'+translation.text+'</p>';
                                        html += '</div>';
                                      } // end if contentType html
      
                                      if(contentType == 'LINK'){
                                      
                                        html += '<div class="content-type-link">';
                                        if(translation.title != '' && translation.title != null){
                                          if(contentData.fontSize != '' && contentData.fontSize != null ){
                                            var textSize = 'font-size:'+contentData.fontSize+'px;';
                                          }else{ var textSize = '' }
                                          
                                          html += '<h3 style="'+textSize+'">'+translation.title+'</h3>';
                                        }
                                        if(translation.linkText != '' && translation.linkText != null){                                 
                                            var btnLinkClass = '';
                                            if(contentData.isButtonLink == '1'){
                                              btnLinkClass = 'button button-link';
                                              html += '<style>.button-link{background-color: '+contentData.backgroundButtonColor+';color:'+contentData.textButtonColor+'}.button-link:hover{background-color:'+contentData.hoverColor+';}</style>';
                                            }                                
                                            html += '<a href="'+translation.link+'" class="'+btnLinkClass+'">';                                
                                            if(translation.linkText != ''){
                                                html += translation.linkText;
                                            }                                  
                                            html += '</a>';
                                        }
                                        if(translation.imageUrl != '' && translation.imageUrl != null){
          
                                          html += '<div class="image-container image-width--'+contentData.pictureSize+' image-text--'+contentData.picturePosition+'" style="text-align:'+contentData.picturePosition+'">';
                                            html += '<div class="image-container-inner">';
                                              html += '<a href="'+translation.link+'">';
                                                html += '<img src="'+translation.imageUrl+'" alt="" class="lazyload" loading="lazy">';
                                              html += '</a>';
                                            html += '</div>';
                                          html += '</div>';
                                          
                                           
                                        }
                                        html += '</div>';
                                      } // end if contentType link
    
                                      if(contentType == 'VIDEO'){
    
                                        var videourl = contentData.videoUrl;
                                        if (videourl == '' || videourl == null){
                                         var videourl = contentData.localVideoUrl;
                                        }
                                        
                                        if(videourl!='' && videourl != null ){
                                            var videoId = youtube_parser(videourl.trim());
                                         
                                            if(videoId!=false){
                                               html += '<div class="content-type-video">';
                                                html += '<iframe title="'+translation.title+'" src="https://www.youtube.be/embed/'+videoId+'?feature=oembed&amp;enablejsapi=1&amprel=0;" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>';
                                               html += '</div>';                                    
                                            } else {                                     
                                              html += '<div class="content-type-video">';
                                                html += '<video controls><source src="'+videourl+'" type="video/mp4"></iframe>';
                                              html += '</div>';                                   
                                            } 
                                        }
                                                                        
                                      } // end if contentType video
    
                                      if(contentType == 'CONTENT_CARD'){
                                        html += '<div class="content-type-content-card">';
                                          html += '<'+contentData.titleSize+'>';
                                            html += translation.title;
                                          html += '</'+contentData.titleSize+'>';
                                          if(translation.text != ''){
                                            html += '<p>'+translation.text+'</p>';
                                          }
                                          if(contentData.picture != '' && contentData.picture ){
                                            html += '<img src="'+contentData.picture+'" class="lazyload" loading="lazy">'
                                          }
                                        html += '</div>';
                                      } // end if contentType CONTENT_CARD
    
                                      if(contentType == 'COLLECTION'){
                                        cole++;
                                        html += '<div class="content-type-collection">';
                                         html += '<'+contentData.titleSize+'>';
                                         html += translation.title;
                                         html += '</'+contentData.titleSize+'>';
                                         
                                         if(translation.description != null){
                                             html += '<p>'+translation.description+'</p>';
                                         }

                                        var fczProducts = contentData.fczProducts;
                                        if(fczProducts.length > 0){
                                                                                
                                          if(contentData.nrOfProductsVisible>4){
                                            var dynamicClass = 'slider-for-news owl-carousel';
                                          } else {
                                            var dynamicClass = '';
                                          }
                                          html += '<div class="'+dynamicClass+' product-list collection-matrix clearfix equal-columns--clear equal-columns--outside-trim">';
                                          for(var p=0;p<fczProducts.length; p++){
                                            var product = fczProducts[p];
                                            var translations = product.translations;
                                            var proUrl = '/products/'+product.urlHandle;
                                            var proPrice = '';
                                            if(product.price.length > 0){
                                              priceCurrency = product.price[0].currencyName;
                                              priceValue = product.price[0].value;
    
                                              proPrice = priceCurrency+' '+priceValue;
                                            }
                                            if(translations.length > 0){
                                              for(var t=0;t<translations.length;t++){
                                                var translation = translations[t];
                                                
                                                if(translation.locale == currentLang){
                                                  html += '<div data-product="'+product.urlHandle+'" class="col-md-3 col-sm-2 col-xs-1 column thumbnail">';                                                
                                                    var proTitle = translation.webName;
                                                   
                                                    html += '<div class="product-wrap">';
                                                      var proImage = translation.image;
                                                      html += '<div class="news-thumbnail-images">';
                                                        html += '<a href="'+proUrl+'">';
                                                        html += '<img src="'+proImage+'" class="lazyload" alt="" width="150">';
                                                        html += '</a>';
                                                      html += '</div>';
                                                    html += '</div>';
                                                    html += '<a class="product-info__caption  gsvalidated" href="'+proUrl+'"><div class="product-details"><div class="product-title">'+proTitle+'</div><div class="product-price">'+proPrice+'</div></div></a>';
                                                  html += '</div>';                                            
                                                }
                                              }
                                            }
                                          }
                                          html += '</div>';
                                        }
                                                
                                         html += '</div>';
                                        
                                       } // end collection
    
                                      } // end lang compare
                                    } // end translation loop
                                  } // Translation code
    
                                  if(contentType == 'CAROUSEL'){                                
                                    html += '<div class="content-type-carousel">';
                                      html += '<div id="news-media-wrapper" class="news-media-wrapper">';
                                      if(contentData.contentCarouselImages.length > 0){
                                        var album_image = contentData.contentCarouselImages;
                                        if(album_image.length > 9){
                                          slidetoshow = 9;
                                        }
                                        html += '<div class="news-slider news-slider-wrapper">';
                                        for(var ai = 0; ai < album_image.length; ai++){
                                          html += '<div class="news-images">';
                                            html += '<img src="'+album_image[ai].picture+'" class="lazyload" alt="">';
                                          
                                            for(var coroa=0; coroa<album_image[ai].translations.length;coroa++){
                                              var translation = album_image[ai].translations[coroa];
                                              if(translation.locale == currentLang){                                             
                                                if(translation.title != null ){
                                                  html += '<span class="caption">'+translation.title+'</span>';
                                                }                                                
                                              }                                              
                                            }    
                                            
                                          html += '</div>';
                                        }
                                        html += '</div>'; // end news-slider-wrapper
                                      html += '</div>';
                                    html += '</div>';
                                    } // end if contentType album
                                  } //end carousal
    
                                  if(contentType == 'ALBUM'){
                                      html += '<div id="news-media-wrapper-1" class="news-media-wrapper content-type-content-album" data-album="album-content-'+(content+1)+'">';
                                      
                                        var album_image = contentData.album.images;
                                        
                                        html += '<div class="news-slider slider-for">';
                                        
                                        if(album_image.length > 9){
                                          slidetoshow = 9;
                                        }
                                        
                                        for(var ai = 0; ai < album_image.length; ai++){
                                          var imgSrc = '';
                                          
                                          if(album_image[ai].optimizedImage != null){
                                            imgSrc = album_image[ai].optimizedImage;
                                          }else{
                                            imgSrc = album_image[ai].url;
                                          }
                                          
                                          html += '<div class="news-images" data-order="'+album_image[ai].order+'">';
                                              html += '<img src="'+imgSrc+'" class="lazyload" alt="">';
    
                                          for(var coroa=0; coroa<album_image[ai].translations.length;coroa++){
                                              var translation = album_image[ai].translations[coroa];
                                              if(translation.locale == currentLang){
                                             
                                               if(translation.alternative_text != null ){
                                                html += '<span class="caption">'+translation.alternative_text+'</span>';
                                              }
                                                
                                              }
                                            }
                                          
                                             
                                          html += '</div>';
                                        }
                                        html += '</div>';
                                        
                                        html += '<div class="news-thumbnail slider-nav">';
                                        
                                        for(var ai = 0; ai < album_image.length; ai++){
                                          var imgSrc = '';
                                          
                                          if(album_image[ai].optimizedImage != null){
                                            imgSrc = album_image[ai].optimizedImage;
                                          }else{
                                            imgSrc = album_image[ai].url;
                                          }
                                          html += '<div class="news-thumbnail-images" data-thumbnail-order="'+album_image[ai].order+'">';
                                              html += '<img src="'+imgSrc+'" class="lazyload" alt="" width="150">';
                                          html += '</div>';
                                        }
                                        html += '</div>';
                                      
                                      html += '</div>';
                                      
                                    } // endif album
    
                                  if(contentType == 'TESTIMONIAL'){
                                    var testimonialImage = contentData.testimonial.image;
                                    html += '<div class="content-type-testimonial">';
                                      html += '<div class="testimonial-wrapper">';
                                        html += '<div class="testimonial-inner">';
                                    
                                        html += `<div class="wie_quote_main_block">
                                            <div class="wie_quote_info">
                                              <p>${contentData.testimonial.text}</p>
                                            </div>`;
                                            if(testimonialImage != null && testimonialImage != ''){
                                            html += `<div class="wie_quote_logo_block">
                                              <img src="${testimonialImage}" alt="" class="lazyload">
                                              `;
                                            }
                                          html += '</div>';
                                        html += '</div>';
                                      html += '</div>';
                                    html += '</div>';
                                  } // end TESTIMONIAL
                                  if(contentType == 'DOCUMENT'){
                                    html += '<div class="content-type-document">';
                                      html += '<style>';
                                      html += '.news-content-wrapper .blog-artical-wrapper .blog-artical-inner .description-wrapper .row__'+(row+1)+' .column__'+(column+1)+' .document-button{ background-color:'+contentData.buttonBackgroundColor+' !important;color:'+contentData.buttonTextColor+' !important;border: 1px solid '+contentData.buttonBorderColor+' !important;padding: 10px; text-decoration: none;}';
                                      html += '.news-content-wrapper .blog-artical-wrapper .blog-artical-inner .description-wrapper .row__'+(row+1)+' .column__'+(column+1)+' .document-button:hover{ background-color:'+contentData.buttonHoverColor+' !important;}';
                                      html += '</style>';

                                       if(contentData.isDocumentDisplayedAsButton == 1){
                                              var btnClass = 'document-button';
                                          }else {
                                              var btnClass = '';
                                          }
                                      var translations = contentData.translations;
                                      if(translations.length > 0){
                                        for(let t=0;t<translations.length; t++){
                                          let translation = translations[t];
                                          if(translation.locale == currentLang){                                             
                                            
                                              html += '<a href="'+translation.document+'" class="'+btnClass+'">'+translation.title+'</a>';
                                              
                                            }                                                
                                          }
                                        }
                                      
                                    html += '</div>';
                                  } // end if contentType DOCUMENT
    
                                  if(contentType == 'DIVIDER'){
                                    html += '<div class="content-type-divider">';
                                      html += '<hr>';
                                    html += '</div>';
                                  } // end if contentType DIVIDER
                                    
                                  html += '</div>'; // end content
                                  
                                } // end if contentData
                              } // end for content
                            } // end if content.length
                          } // end if contentContainer
                        html += '</div>'; // end content-column
                      } // end for column
                    } // end if column.length
                  html += '</div>'; // end content-row  
                } // end for rows
              } // end if rows.length
            }

            if(showcontentBuilder == 'false'){
              if(data.description != '' && data.description != null){
                html += `<div class="news-description">${data.description}</div>`;
              }
            }
    
            html += '</div> <!-- end .description-wrapper -->';
    
          html += '</div>';
        html += '</div> <!-- blog-artical-wrapper -->';
      
      html += '</div> <!-- .page-width -->';
      html += '</div> <!-- .news-content-wrapper -->';

      $('#news-details-container').html(html);
      $('.content-type-content-album').each(function(i){
          var albumContainer = $(this).attr('data-album');
          $('#news-details-container .content-type-content-album[data-album="'+albumContainer+'"] .news-slider').html($('#news-details-container .content-type-content-album[data-album="'+albumContainer+'"] .news-slider .news-images').sort(function(x, y) {
           var value_x = $(x).data('order');
           var arr_x = [];
           arr_x = value_x
                
           var value_y = $(y).data('order');
           var arr_y = [];
           arr_y = value_y
      
           var arel = parseInt( arr_x);
           var brel = parseInt(arr_y);             
      
          return arel < brel ? -1 : 1;
         }));
  
          $('#news-details-container .content-type-content-album[data-album="'+albumContainer+'"] .news-thumbnail').html($('#news-details-container .content-type-content-album[data-album="'+albumContainer+'"] .news-thumbnail .news-thumbnail-images').sort(function(x, y) {
           var value_x = $(x).data('thumbnail-order');
           var arr_x = [];
           arr_x = value_x
                
           var value_y = $(y).data('thumbnail-order');
           var arr_y = [];
           arr_y = value_y
      
           var arel = parseInt( arr_x);
           var brel = parseInt(arr_y);             
      
          return arel < brel ? -1 : 1;
         }));
      });
      
      
        $('.preloading').remove();

        ajaxComplete = true;
        
     destroyCarousel();
      setTimeout(function(){
        slickCarousel();
      },1000);
      });
    }
    else
    {
      
      $('#status').fadeOut();
      $('#preloader').fadeOut('slow');
    
      html += '<div class="grid grid--4-col-desktop grid--2-col-tablet-down">';

      for(var a=0; a<totalData; a++){
        var json_response = response.data[a].attributes;
        var imagesrc = '';
        var title = jQuery.trim(json_response.name);
        var description = '';

        if(json_response.excerpt != null){
          description = json_response.excerpt;
        }else {
          description = '';
        }          
       
        if(json_response.optimizedListImage != null){
          imagesrc = json_response.optimizedListImage;
        }else if(json_response.optimizedImage != null){
          imagesrc = json_response.optimizedImage;
        }else if(json_response.image != null){
          imagesrc = json_response.image;
        }else if(json_response.headlineImage != null){
          imagesrc = json_response.headlineImage;
        }else{
          imagesrc = 'https://cdn.shopify.com/s/files/1/0652/7788/6688/files/PW_Icon_trans.webp?v=1663832046';
        }

        var focusXPercentage = "";
        if(json_response.focusXPercentage != null){
          focusXPercentage = json_response.focusXPercentage+'%';
        }else {
          focusXPercentage = 'top';
        }
  
        var focusYPercentage = "";
        if(json_response.focusYPercentage != null){
          focusYPercentage = json_response.focusYPercentage+'%';
        }else {
          focusYPercentage = 'center';
        }
        
        var newscat = '';
        if(json_response.newsCategory !== null ){

          for(var nc=0; nc <json_response.newsCategory.translations.length; nc++){
              newscat += ' '+json_response.newsCategory.translations[nc].webName;
          }
        }
        
        var url=response.data[a].id;
        if(response.data[a].attributes.urlHandle != null){
          var url = response.data[a].attributes.urlHandle;
        }

          html += '<div class="grid__item'+newscat+'">';
              html += '<div class="news-wrapper">';
                  html += '<div class="image-wrapper">';
                      html += '<img src="'+imagesrc+'" width="320" loading="lazy" style="object-position: '+focusXPercentage+' '+focusYPercentage+'">';
                  html += '</div>';
                  html += '<div class="content-wrapper">';
                      html += '<div class="newsblock__date">'+formatDateString(response.data[a].attributes.publishDate,'regular','false')+'</div>';
                      html += '<h3 class="newsblock__title">'+title+'</h3>';
                      html += '<div class="newsblock__details">'+description+'</div>';
                  html += '</div>';
                  html += '<div class="link-wrapper">';
                      html +='<a href="/pages/news/'+url+'" class="block-btn">';
                          html += '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M256 64C256 46.33 270.3 32 288 32H415.1C415.1 32 415.1 32 415.1 32C420.3 32 424.5 32.86 428.2 34.43C431.1 35.98 435.5 38.27 438.6 41.3C438.6 41.35 438.6 41.4 438.7 41.44C444.9 47.66 447.1 55.78 448 63.9C448 63.94 448 63.97 448 64V192C448 209.7 433.7 224 416 224C398.3 224 384 209.7 384 192V141.3L214.6 310.6C202.1 323.1 181.9 323.1 169.4 310.6C156.9 298.1 156.9 277.9 169.4 265.4L338.7 96H288C270.3 96 256 81.67 256 64V64zM0 128C0 92.65 28.65 64 64 64H160C177.7 64 192 78.33 192 96C192 113.7 177.7 128 160 128H64V416H352V320C352 302.3 366.3 288 384 288C401.7 288 416 302.3 416 320V416C416 451.3 387.3 480 352 480H64C28.65 480 0 451.3 0 416V128z"></path></svg>';
                      html += '</a>';
                  html += '</div>';
              html += '</div>';
          html += '</div>';
      }
      
      if(totalData == 0){
        html +='<p class="empty-category-text">Für diese Kategorie sind keine Nachrichten verfügbar.</p>';
      } 
      html +='</div>';
      
      $('#news-container').html(html);
    }
    
    
    if(flag == 0){

      var pagi = '';

      var currentPage = response.meta.page.currentPage;
      var from = response.meta.page.from;
      var lastPage = response.meta.page.lastPage;
      var perPage = response.meta.page.perPage;
      var to = response.meta.page.to;
      var $pages = response.meta.page.total;
      var $num_links = 3;

      var $start = ((currentPage - $num_links) > 0) ? (currentPage - ($num_links - 1)) : 1;
      var $end   = ((currentPage + $num_links) < lastPage) ? (currentPage + $num_links) : lastPage;
      
      if(getParameterByName('category') == null){
        if(getParameterByName('player') != null){
          var pg = '?player='+getParameterByName('player')+'&page=';
        }else{
          var pg = '?page=';
        }
        
      }else{
        var pg = '?category='+getParameterByName('category')+'&page=';
      }

      if($pages > 1){    

        if(currentPage > 1) {
          
          pagi += '<li>';
          pagi += '<a href="/pages/news'+pg+(currentPage-1)+'" class="pagination__item pagination__item--prev pagination__item-arrow link motion-reduce">';
          pagi += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path> </svg>';
          pagi += '</a>';
          pagi += '</li>';
        }                 

        if(currentPage > 3) 
        {
          pagi += '<li><a href="/pages/news'+pg+'1" class="pagination__item link">1</a></li>';
          pagi += '<li><span class="pagination__item">...</span></li>';
        }
        for(var $x=$start ; $x<$end ;$x++)
        {

          pagi += '<li>';

          if($x == currentPage)
          {
            pagi += '<span class="pagination__item pagination__item--current" aria-current="page" >'+$x+'</span>';
          }
          else
          {
            pagi += '<a href="/pages/news'+pg+$x+'" class="pagination__item link">'+$x+'</a>';
          }
          pagi += '</li>';

        }
        if(currentPage < lastPage){
          pagi += '<li><span class="pagination__item">...</span></li>';
          pagi += '<li><a href="/pages/news'+pg+lastPage+'" class="pagination__item link">'+lastPage+'</a></li>';

        }

        if(currentPage < lastPage )
        {
          pagi += '<li>';
          pagi += '<a href="/pages/news'+pg+(parseInt(currentPage)+1)+'" class="pagination__item pagination__item--next pagination__item-arrow link motion-reduce">';
          pagi += '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"> </path> </svg>';
          pagi += '</a>';
          pagi += '</li>';
        }

      }

      $('#news-pagination .pagination__list').html(pagi);
    }
  });
  
  
  function slickCarousel() {
    $('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinate: true,
      arrows: true,
      asNavFor: '.slider-nav',
      adaptiveHeight: true
    });
    $('.slider-nav').slick({
      slidesToShow: slidetoshow,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      centerMode: true,
      focusOnSelect: true,
      infinate: true,
      responsive: [
        {
            breakpoint: 767,
            settings: {
              slidesToShow: 7,
            }
        },
        {
            breakpoint: 540,
            settings: {
              slidesToShow: 5,
            }
        }
      ]
    });

    $('.slick-aufstellung').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      prevArrow:'<button type="button" data-role="none" class="slick-prev slick-arrow" aria-label="Prev" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="left"><path d="M4.409 11l9.061-9.061 2.121 2.121-6.939 6.939 6.939 6.939-2.121 2.121z" fill="#fff"></path></svg><span>Ersatzbank</span></button>',
      nextArrow:'<button type="button" data-role="none" class="slick-next slick-arrow" aria-label="Next" role="button"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" class="right"><path d="M8.53 20.061l-2.121-2.121 6.939-6.939-6.939-6.939 2.121-2.121 9.061 9.061z" fill="#fff"></path></svg><span>Ersatzbank</span></button>'
    });
    
    $('.slick-aufstellung').slick('slickGoTo', 1);

    $('.slick-aufstellung-mobile').slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false
    });
  }
  function destroyCarousel() {
    if ($('.slider-for').hasClass('slick-initialized')) {
      $('.slider-for').slick('destroy');
    }
    if ($('.slider-nav').hasClass('slick-initialized')) {
      $('.slider-nav').slick('destroy');
    }

    if ($('.slick-aufstellung').hasClass('slick-initialized')) {
      $('.slick-aufstellung').slick('destroy');
    }

    if ($('.slick-aufstellung-mobile').hasClass('slick-initialized')) {
      $('.slick-aufstellung-mobile').slick('destroy');
    }
  }
});

// News Categories      
var settings = {
  "url": "https://app.aico.swiss/19853/api/v1/news-categories?page[number]=1&page[size]=10&sort=sortingNumber",
  "method": "GET",
  "timeout": 0,
  "headers": {
    "Authorization": Authorization,
    "Accept": "application/vnd.api+json"
  },
};

$.ajax(settings).done(function (response) {

  var totalData = response.data.length;

  var html='';
  
  
  for(var a=0 ; a < totalData ; a++){
    var active = '';
    if(getParameterByName('category') != null){
      var current_cat = getParameterByName('category');
    }else{
      var current_cat = '';
    }
    if(current_cat == response.data[a].attributes.translations[0].id){
      var active = 'active';
    }else{
      var active = '';
    }
    
    if(response.data[a].attributes.isActive==1){
      html += '<button class="btn '+active+'" data-id="'+response.data[a].attributes.translations[0].webName+'" data-catid="'+response.data[a].attributes.translations[0].id+'" >'+response.data[a].attributes.translations[0].webName+'</button>';
    }
  }
  if(current_cat == ''){
    var active = 'active';
  }else{
    var active = '';
  }
  html += '<button class="btn '+active+'" data-id="*">Alle Artikel</button>';
  $('#filter-container').html(html);
});


//news filter
$(document).on('click','#filter-container .btn', function(){
  $(this).toggleClass('active');
  
  if($(this).hasClass('active')){
    var dataCat = $(this).data('catid');
    if(typeof dataCat !== 'undefined'){
        window.location.href="/pages/news?category="+dataCat;
    }else{
      window.location.href="/pages/news";
    }
  }else{
    window.location.href="/pages/news";
  }
  
});
